import { Paper } from '@mui/material';
// import useMediaQuery from '@mui//core/useMediaQuery';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { AppBreadcrumbs, AppLoading } from '../../../components';

export default function MainPage({ classes, children }) {
  const isMobile = false//useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { loadingMain, showBreadCrums } = useSelector((state) => state.layout);

  /**
   * renders
   */
  return (
    <main className={clsx(classes.content, { [classes.contentMobile]: isMobile, [classes.contentFull]: !showBreadCrums }) + ' immerse-contentbg'}>
      <div className={classes.toolbar} />
      <div>
        {/* <AppBreadcrumbs /> */}

        {showBreadCrums ? (
          <Paper className="main-paper" elevation={3}>
            {children}
          </Paper>
        ) : (
          <div className="main-box">{children}</div>
        )}

        {loadingMain && (
          <div className="loading-main">
            <AppLoading />
          </div>
        )}
      </div>
    </main>
  );
}
